import {useQuery} from "@tanstack/react-query";
import React from "react";
import {BasicSearchType} from "../../../../types/common/basic";
import {readRmaApi} from "../../../../api/support/RMA";

type Props = {
    searchOption: BasicSearchType;
};

const useReadRma = ({searchOption}: Props) => {
    const {data} = useQuery({
        queryKey: ["readRmaList", searchOption],
        queryFn: async () => await readRmaApi(searchOption),
        // staleTime: 6000 * 10,
        select: (res) => res?.result,
    });
    return {data};
};

export default useReadRma;
